import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const minWidth = css`
    min-width: 80px;
`;

export const noMargin = css`
    div {
        /* override sds tooltip styles */
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
`;

export const IconWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    min-width: 16px;

    /* override sds tooltip styles */
    margin: 0 !important;

    .sds-icon-warning {
        /* sds icon has space within inner path, adjusting */
        margin-left: -1.5px;

        path:nth-child(2),
        path:nth-child(3) {
            fill: ${Colors.Black.V50};
        }
    }
`;
